export enum ImportScheduleReturnCodes
{
    Success = 0,
    ExcelNotFound = 1,
    DataNotFound = 2,
    DuplicateName = 3,
    GeneralError = 4,
    NoFileSelected = 5
}